export const getQueryStringValue = (key: string): string => {
	// eslint-disable-next-line no-undef
	const url = globalThis?.location?.search;
	if (url) {
		try {
			const urlParams = new URLSearchParams(url);
			return urlParams.get(key)?.replace(/ /g, '+') ?? '';
		} catch (error) {
			console.error('Error parsing URL parameters:', error);
			return '';
		}
	}
	return '';
};

export const scrollToBottom = (
	elementId: string,
	behavior: 'auto' | 'smooth' = 'smooth',
) => {
	const element = document.getElementById(elementId);
	if (element) {
		element.scrollTo({
			top: element.scrollHeight,
			behavior,
		});
	} else {
		// Fallback to window scroll for desktop or other layouts
		window?.scrollTo({
			top: document.body.scrollHeight,
			behavior,
		});
	}
};

// Use double requestAnimationFrame to ensure DOM has updated before executing callback
export const runAfterPaint = (callback: () => void) => {
	requestAnimationFrame(() => requestAnimationFrame(callback));
};
